import { all } from 'redux-saga/effects'
// import SignupSaga from '../signup/sagas'
import AuthSaga from 'App/auth/sagas'

export default function* IndexSaga() {
  yield all([AuthSaga()])
}
